import { StackChildren, Text } from '@doordash/design-language'
import * as React from 'react'
import { ComponentWrapper } from '../../molecules/workflow-components'
import { TemplateResponseData, ComponentProps, SectionProps } from './types'
import { SubmitOnboardingCallback } from '../../pages/onboarding-workflow/OnboardingWorkflow'

type Section = {
  section: SectionProps
  onDataUpdate: (path: string, value) => void
  templateResponseData: TemplateResponseData
  onSubmitStep: SubmitOnboardingCallback
}

export const Section: React.FC<Section> = ({
  section,
  onDataUpdate,
  templateResponseData,
  onSubmitStep,
}) => (
  <StackChildren size={StackChildren.Sizes.XxSmall}>
    {section.header && (
      <Text styles={Text.Styles.Title1}>{section.header}</Text>
    )}
    {section.sub_header && (
      <Text styles={Text.Styles.Body2}>{section.sub_header}</Text>
    )}
    {section.components.map((component: ComponentProps, index: number) => (
      <div key={index}>
        {ComponentWrapper(
          component,
          templateResponseData,
          onDataUpdate,
          onSubmitStep
        )}
      </div>
    ))}
  </StackChildren>
)
